import { Grid, makeStyles } from '@material-ui/core';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import NavWrapper from './widgets/NavWrapper';
import NavFooter from './widgets/NavFooter';
import NavLogo from './widgets/NavLogo';

const useStyles = makeStyles((theme) => ({
  navBar: {
    flexShrink: 0,
    width: 70,
    minWidth: 70,
    transition: '0.3s',
    flexWrap: 'nowrap',
    background: 'linear-gradient(180deg, #2E48D3 0%, #5B65DC 100%)',
    height: '100vh',
    position: 'relative',
  },
  pinnedNavBar: {
    width: 240,
    flexWrap: 'nowrap',
    background: 'linear-gradient(180deg, #2E48D3 0%, #5B65DC 100%)',
    height: '100vh',
    transition: '0.3s',
  },
}));

const NavBar = () => {
  const classes = useStyles();
  const { isSideMenuPinned } = useSelector((state) => state.appSettings);
  return (
    <Grid
      container
      direction='column'
      id={'navBar'}
      className={cx(classes.navBar, {
        [classes.pinnedNavBar]: isSideMenuPinned,
      })}
    >
      <NavLogo />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: 'calc(100% - 84px)',
          position: 'relative',
        }}
      >
        <NavWrapper />
        <NavFooter />
      </div>
    </Grid>
  );
};

export default NavBar;
